import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class PatternValidatorsService {
  static patternValidators(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): Record<string, unknown> => {
      if (!control.value) {
        return {};
      }
      const valid = regex.test(control.value);

      return valid ? {} : error;
    };
  }
}
